export default function createHashMap (array, key) {
    if (array && array.length > 0 && key && key.length > 0) {
      const hashMap = array.reduce((acc, currentValue) => {
        acc[currentValue[key]] = currentValue;
        return acc;
      }, {});
      return hashMap;
    }
    return {};
};